module.exports = __webpack_public_path__ + "img/legal.4bfddaa7.png";